import router from '../router'

//const API_URL = 'http://localhost:9001/'
const API_URL = 'https://nextapiv2.arkman.com.tr/'
//const API_URL = 'http://84.44.39.36:8080/' //kunet guncel
//const API_URL = 'https://arkmanapi.shallwego.com:443/'
//const API_URL = 'https://nextapi.gezinomi.com/'
//const API_URL = 'https://nextapi.antur.com.tr/'
//const API_URL = 'http://nextapi.sampa.com/' // SAMPA
//const API_URL = 'http://arkmanapi.mngtour.com/' // MNG
//const API_URL = 'http://192.168.16.139:8090/'  //PRONTO
//const API_URL = 'http://172.20.1.54:8090/'  //PRONTO YENI
//const API_URL = 'http://localhost:8080/' //kurulum ve easy travel
//const API_URL = 'https://nextapi.arkas.com:443/'
//const API_URL = 'http://nextapi.bekturizm.com/'    // BEK
//const API_URL = 'https://nextapi.msctr.com:443/'  //  // cisaplina 
//const API_URL = 'http://nextapi.polsan.com.tr/'    // POLSAN
//const API_URL = 'http://192.168.0.8:8080/'    // GAZELLA TURIZM
//const API_URL = 'http://nextapi.visa34.com/'    // HERMES TURIZM
//const API_URL = 'http://nextapi.superpay.tech/'    // SUPERPAY TURIZM
//const API_URL = 'http://nextapi.dorak.com/'    // DORAK TURIZM
//const API_URL = 'http://nextapi.turplus.com.tr:8090/'   // TURPLUS TURIZM
//const API_URL = 'http://172.31.10.178:8070/'   // GAZIGLOBAL TURIZM
//const API_URL = 'https://arkmanapi-tst.yasar.net/' // BIN TUR
//const API_URL = 'https://arkmanapi.yasar.net/' // BIN TUR LIVE
//const API_URL = 'http://nextapi.cappadocetour.com/' //cappadoce
//const API_URL = 'http://nextapi.biletsepeti.com/' // biletsepeti Yeni TUR
//const API_URL = 'http://nextapi.geziburda.com/' // geziburda  TUR
//const API_URL = 'http://10.0.0.5:8090/'    // Vizyon TURIZM
//const API_URL = 'http://192.168.1.105:8093/'   // PROFIT TURIZM
//const API_URL = 'http://nextapi.freebirdtravel.com/'  //freebirdtravel
//const API_URL = 'https://nextapi.akyakatur.com.tr/'  //akyakatur
//const API_URL = 'http://192.168.1.253:8080/'    // Kontour TURIZM
//const API_URL = 'https://nextapi-stage.biletsepeti.com/' // biletsepeti STAGE TUR

//const URL_MAIL = 'https://nextarkman-stage.biletsepeti.com/#/confirm/id?' //biletsepeti
//const URL_MAIL = 'http://192.168.1.253:8081/#/confirm/id?'    // Kontour TURIZM
//const URL_MAIL = 'https://nextarkman.akyakatur.com.tr/#/confirm/id?' // akyakatur 
//const URL_MAIL = 'http://nextarkman.freebirdtravel.com/#/confirm/id?' // freebirdtravel TURIZM
//const URL_MAIL = 'http://192.168.1.105:8080/#/confirm/id?' // PROFIT TURIZM
//const URL_MAIL = 'http://10.0.0.5:8070/#/confirm/id?'    // Vizyon TURIZM
//const URL_MAIL = 'http://nextarkman.geziburda.com/#/confirm/id?' //geziburda
//const URL_MAIL = 'http://nextarkman.biletsepeti.com/#/confirm/id?' //biletsepeti
//const URL_MAIL = 'http://nextarkman.cappadocetour.com/#/confirm/id?' //cappadoce
//const URL_MAIL = 'https://arkmannext.yasar.net/#/confirm/id?'  // BIN TUR LIVE
//const URL_MAIL = 'https://arkmannext-tst.yasar.net/#/confirm/id?'  // BIN TUR
//const URL_MAIL = 'http://172.31.10.178:8080/'  // GAZIGLOBAL TURIZM
//const URL_MAIL = 'http://next.turplus.com.tr:8080/#/confirm/id?'  // TURPLUS TURIZM
//const URL_MAIL = 'http://nextarkman.dorak.com/#/confirm/id?' // HERMES TURIZM
//const URL_MAIL = 'http://nextarkman.superpay.tech/'    // SUPERPAY TURIZM
//const URL_MAIL = 'http://nextarkman.visa34.com/#/confirm/id?' // HERMES TURIZM
//const URL_MAIL = 'http://192.168.0.8:80/#/confirm/id?'  //  // GAZELLA TURIZM
//const URL_MAIL = 'http://nextarkman.polsan.com.tr/#/confirm/id?' // POLSAN
//const URL_MAIL = 'https://nextarkman.msctr.com:443/#/confirm/id?' //  cisaplina
//const URL_MAIL = 'http://nextarkman.bekturizm.com/#/confirm/id?' // BEK
//const URL_MAIL = 'http://nextarkman.arkas.com/#/confirm/id?'
//const URL_MAIL = 'http://172.20.1.54:8080/#/confirm/id?'  // PRONTO YENI
//const URL_MAIL = 'http://192.168.16.139:8080/#/confirm/id?'  // PRONTO
//const URL_MAIL = 'http://nextarkman.mngtour.com.tr/#/confirm/id?' //MNG
//const URL_MAIL = 'http://nextarkman.sampa.com/#/confirm/id?'
//const URL_MAIL = 'http://nextarkman.antur.com.tr/#/confirm/id?'
//const URL_MAIL = 'http://nextarkman.gezinomi.com/#/confirm/id?'
//const URL_MAIL = 'http://localhost:8080/#/confirm/id?' // kurulum ve easy travel
const URL_MAIL = 'http://nextv2.arkman.com.tr/#/confirm/id?'
//const URL_MAIL = 'http://muhasebe.kunet.com.tr/#/confirm/id?' //kunet
//const URL_MAIL = 'https://arkmannext.shallwego.com/#/confirm/id?'

const REPORTBRO_URL = 'http://wapi.arkman.com.tr:8801'
const TOKEN_URL = API_URL + 'token'



export default {
  user: {
    authenticated: false,
    email: ''
  },
  API_URL: API_URL,
  URL_MAIL: URL_MAIL,
  REPORTBRO_URL: REPORTBRO_URL,


  login(context, creds, id) {
    context.$http.post(API_URL + 'api/Dot9/Dot9UserExist', creds, {
      headers: {
        'Authorization': 'Bearer ' + null
      }
    }).then((response) => {

      if (response.body.Exist == true) {

        var credentials = {
          CariBilgi: response.body.CariInfo,
          Id: id
        }
        window.localStorage.removeItem('credentials')
        window.localStorage.setItem('credentials', JSON.stringify(credentials));
        window.localStorage.setItem('tokenreport', response.body.TokenDot9.token);
        router.push({
          path: '/'
        })

        context.bekle = false;
      } else {
        context.errorMsg = 'Giriş yapılamadı. Lütfen bilgilerinizi kontrol ediniz.'
        context.errorAlert = true
        context.bekle = false;

      }



    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })





  },
  logingiris(context, creds, redirect) {

    context.$http.post(TOKEN_URL, creds).then((response) => {

      this.user.authenticated = true
      this.user.email = creds.Email


      window.localStorage.removeItem('response')
      window.localStorage.setItem('response', JSON.stringify(response.body))
      var response = JSON.parse(window.localStorage.getItem('response'));
      window.localStorage.setItem('tokenreport', response.Token.token);

      router.push({
        path: '/'
      })

    }, (response) => {
      if (response.status === 0) {
        context.text1 = 'Service Unavailable'
        context.snackbar = true
      } else {
        context.text1 = 'Giriş yapılamadı. Lütfen bilgilerinizi kontrol ediniz.'
        context.snackbar = true
      }
    })
  },

  logout() {


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    window.localStorage.removeItem('tokenreport')
    // window.localStorage.removeItem('credentials')

    var id = 0
    if (credentials != null) {
      id = credentials.Id
    } else {
      id = 0
    }

    router.push({
      path: '/login/' + id
    })

  },
  checkAuth() {

    var jwt = window.localStorage.getItem('tokenreport')

    if (jwt) {
      this.user.authenticated = true
      return true
    } else {
      this.user.authenticated = false
      return false //normalde false burası
    }
  },
  getAuthHeader() {
    return window.localStorage.getItem('tokenreport')
  }
}